import { TableCellAlignmentEnum } from './TableCellAlignmentEnum';
import { TableColumnOptions } from './TableColumnOptions';

export class TableColumn {
  public definition!: string;
  public header!: string;
  public display?: (row: unknown) => number | string | string[];
  public link?: (row: unknown) => string;
  public sortable?: boolean;
  public width?: number;
  public options?: TableColumnOptions;
  public checkAll?: (data: any) => void;
  public onInputChange?: (value: string, row: any) => void;
  public valueClickHandler?: (row: any) => void;

  constructor(
    definition: string,
    header?: string,
    display?: (x: unknown) => number | string | string[],
    sortable?: boolean,
    width?: number,
    options?: TableColumnOptions,
    checkAll?: (data: unknown) => {},
    link?: (x: unknown) => string,
    onInputChange?: (value: string, row: any) => void,
    valueClickHandler?: (row: any) => void,
  ) {
    this.definition = definition;
    this.header = header || '';
    this.display = display;
    this.link = link;
    this.sortable = sortable ?? false;
    this.width = width ?? 0;
    this.options = options ?? new TableColumnOptions();
    this.checkAll = checkAll;
    this.onInputChange = onInputChange;
    this.valueClickHandler = valueClickHandler;
  }

  public getStyle(row?: number | string | string[]): string {
    let style =
      this.options?.styleExpression +
      `min-width: ${this.width}px !important; max-width: ${this.width}px !important;`;

    switch (this.options?.alignment) {
      case TableCellAlignmentEnum.LEFT:
        style = style + 'text-align: left;';
        break;
      case TableCellAlignmentEnum.CENTER:
        style = style + 'text-align: center;';
        break;
      case TableCellAlignmentEnum.RIGHT:
        style = style + 'text-align: right;';
        break;
    }

    if (row && this.options?.conditionalCss) {
      style += this.options?.conditionalCss(row);
    }
    return style;
  }
}
